import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Visitor } from 'src/app/admin/models/visitor';
import { VisitorService } from 'src/app/admin/services/visitor.service';

@Component({
  selector: 'app-delete-visitor-modal',
  templateUrl: './delete-visitor-modal.component.html',
  styleUrls: ['./delete-visitor-modal.component.scss'],
})

export class DeleteVisitorModalComponent implements OnInit {
  visitor: Visitor;
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  itemsPerPage: number = 20;
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  usernameQuery: string = '';
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  fullNameQuery: string = '';
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  emailQuery: string = '';
  phoneQuery: string = '';
  visitorStatusQuery = '';
  currentPage: number = 1;
  onlyChildren: boolean = false;
  marketingMessageQuery: string = '';
  dateBirthFromQuery:string=''
  dateBirthToQuery:string=''
  registrationDateFromQuery:string=""
  registrationDateToQuery:string=""
   visitorBirthMonthFromQuery:string=""
   visitorBirthMonthToQuery:string=""
  visitorBirthYearFromQuery:string=""
  visitorBirthYearToQuery:string=""

  constructor(private modalController: ModalController, private visitorService: VisitorService) { }

  ngOnInit() { }

  removeUser() {
    this.visitorService.deleteVisitor(this.visitor.id).subscribe(res => {
      this.visitorService.getAllVisitorsSearch({
        currentPage: this.currentPage, itemsPerPage: this.itemsPerPage,
        fullNameQuery: this.fullNameQuery, emailQuery: this.emailQuery, phoneQuery: this.phoneQuery, visitorStatusQuery: this.visitorStatusQuery,
        onlyChildren: this.onlyChildren,
        marketingMessageQuery: this.marketingMessageQuery,dateBirthFromQuery:this.dateBirthFromQuery, dateBirthToQuery:this.dateBirthToQuery,        
      registrationDateFromQuery:this.registrationDateFromQuery, registrationDateToQuery:this.registrationDateToQuery,
       visitorBirthMonthFromQuery:this.visitorBirthMonthFromQuery,visitorBirthMonthToQuery:this. visitorBirthMonthToQuery,
       visitorBirthYearFromQuery:this.visitorBirthYearFromQuery,visitorBirthYearToQuery:this. visitorBirthYearToQuery
   
      
      });
      this.dismissModal();
    }, (err) => {
      console.error(err);
    });
  }

  dismissModal() {
    this.modalController.dismiss();
  }

}
